import Icon from 'veui/components/Icon'

Icon.register({
  'info-circle': {
    paths: [
      {
        d: 'M24 0a24 24 0 100 48 24 24 0 000-48zm0 4a20 20 0 110 40 20 20 0 010-40zm-2 32a2 2 0 104 0V20a2 2 0 10-4 0v16zm0-22a2 2 0 104 0v-1a2 2 0 10-4 0v1z'
      }
    ],
    width: '48',
    height: '48'
  }
})
